module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("\n  " + _vm._s(_vm.replacedText) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c461cb8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=ba0n6m0pdol!./~/string-replace-webpack-plugin/loader.js?id=vjdso5oqwij!./src/components/product/DonateTitle.vue
// module id = 628
// module chunks = 0